<template>
    <div style="background: #F6F6F6;">
        <van-pull-refresh v-model="isInfoLoading" @refresh="onRefresh"
                          pulling-text="Se puede actualizar desplegando..."
                          loosing-text="Se puede actualizar liberando..."
                          loading-text="En carga..."
        >
            <div class="audithome_wrap" id="firstloan_head">
                <div class="audithome_head">
                    <div class="audithome_hleft">Superapoyomax</div>
                    <div class="audithome_hright">
                        <div class="audithome_hrimg" @click.stop="onHomeCenter">
                            <!--<img src="../../assets/img/audithome_icon01.png" />-->
                        </div>
                        <div class="audithome_hrimg" @click.stop="onHomeMenus">
                            <!--<img src="../../assets/img/audithome_icon02.png" />-->
                        </div>
                    </div>
                </div>
                <div class="audithome_tps">
                    <div class="audithome_tps_text"> Un gusto poder saludarte</div>
                    <div class="audithome_tps_text"> Cuentas con un pago pendiente de tu préstamo</div>
                </div>
            </div>

            <div id="firstloan">
                <div class="audithome_cont">
                    <div class="audithome_cview">
                        <div class="auditpass_wrap">
                            <div class="mainview_itoken_wrap">
                                <div class="repayment_wrap">
                                    <div class="repayment_cont">
                                        <div class="repayment_head">
                                            <div class="repayment_hleft">Pendiente de pago</div>
                                            <div class="repayment_hright" @click="detailShow = true">
                                                <div class="repayment_hrtext">Detalles</div>
                                                <div class="repayment_hricon">
                                                    <img src="@/assets/mobimg/repayment_arrowright.png" alt="">
                                                </div>
                                            </div>
                                        </div>
                                        <template v-if="repaymentInfo">
                                            <div class="repayment_amount" :class="repaymentInfo.order_status == 9 ?'repayment_amount_two' : ''">
                                                <div><span>$</span>{{repaymentInfo.unpaid_amount}}</div>
                                                <div class="repayment_amview" v-if="repaymentInfo.order_status == 9">
                                                    <div class="repayment_amvimg">
                                                        Atrasado
                                                    </div>
                                                </div>
                                            </div>
                                        </template>

                                        <div class="repayment_times" v-if="repaymentInfo">
                                            <div>Fecha final de pago:</div>
                                            <span>{{repaymentInfo.repay_time}}</span>
                                        </div>

                                        <!--<div class="repayment_coupons">
                                            <div class="repayment_coupons_view">
                                                <div class="repayment_cupsleft">
                                                    <div class="repayment_cupslicon">
                                                        <img src="@/assets/mobimg/repayment_cupslicon.png" alt="">
                                                    </div>
                                                    <div class="repayment_cupsltext">Cupón</div>
                                                </div>

                                                <div class="repayment_cupsright">
                                                    &lt;!&ndash;<div class="repayment_cupsrtext"><span>3</span>disponible(s)</div>
                                                    <div class="repayment_cupsricon">
                                                        <img src="@/assets/mobimg/repayment_arrowright.png" alt="">
                                                    </div>&ndash;&gt;

                                                    <div class="repayment_cupsrtext">
                                                        <template v-if="couponsList && couponsList.length">
                                                            <template v-if="couponsObj">
                                                                <template v-if="couponsObj.coupon_type == 1">
                                                                    <p style="color: #DB861F;">
                                                                        <span style="color: #DB861F;">-</span>${{couponsObj.distribute_amount}}
                                                                    </p>
                                                                </template>
                                                                <template v-else-if="couponsObj.coupon_type == 4">
                                                                    <p style="color: #DB861F;">
                                                                        <span style="color: #DB861F;">+</span>${{couponsObj.distribute_amount}}
                                                                    </p>
                                                                </template>
                                                            </template>
                                                            <template v-else>
                                                                <span>{{couponsList.length}}</span>disponible(s)
                                                            </template>
                                                        </template>
                                                        <template v-else>
                                                            No utilizar el cupón
                                                        </template>
                                                    </div>

                                                    <div class="repayment_cupsricon">
                                                        <img src="@/assets/mobimg/repayment_arrowright.png" alt="">
                                                    </div>

                                                </div>
                                            </div>
                                            <div class="itoken_check_vidown" v-if="couponsObj">
                                                <div class="itoken_check_vidleft"></div>
                                                <div class="itoken_check_vidright">{{couponsObj.name}}</div>
                                            </div>
                                        </div>-->

                                        <div class="repayment_middle">
                                            <div class="repayment_mtop">
                                                <div class="repayment_mtview">
                                                    <div class="repayment_mttitle">Pago con tarjeta bancaria</div>
                                                    <div class="repayment_mtone">
                                                        <div class="repayment_mtone_cont" @click="cardShow = true">
                                                            <div class="repayment_mtonecleft">
                                                                <img src="@/assets/mobimg/payment_spe.png" alt="">
                                                            </div>
                                                            <div class="repayment_mtonecright">
                                                                <div class="repayment_mtonecr_cont">
                                                                    <input type="text" :value="card_val" />
                                                                    <div class="repayment_mtonecr_dv"></div>
                                                                </div>
                                                                <div class="repayment_mtonecr_icon">
                                                                    <img src="@/assets/mobimg/repayment_cupsricon.png" alt="">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="repayment_mttwo">
                                                        <div class="repayment_mttwo_cont">
                                                            <div class="repayment_mttwo_cleft">
                                                                Pagar en línea. Comisión <span>0 MXN</span>
                                                            </div>
                                                            <template v-if="card_val">
                                                                <div class="repayment_mttwo_cright" @click="copy(card_val)">
                                                                    <span>Copiar</span>
                                                                </div>
                                                            </template>
                                                            <template v-else>
                                                                <div class="repayment_mttwo_cright">
                                                                    <span>Copiar</span>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                    <div class="repayment_mtthr">
                                                        <div class="repayment_mtthr_cont" v-if="repaymentInfo">
                                                            <div class="repayment_mtthr_cleft">
                                                                <div class="repayment_mtthr_clicon">
                                                                    <template v-if="repaymentInfo.order_status == 9">
                                                                        <van-icon size="16" name="warning" color="#BDA170" />
                                                                    </template>
                                                                    <template v-else>
                                                                        <van-icon size="16" name="warning" color="#A7A7A7" />
                                                                    </template>
                                                                </div>
                                                            </div>
                                                            <div class="repayment_mtthr_cright" :class="repaymentInfo.order_status == 9 ? 'repayment_mtthr_crtwo': ''">
                                                                Puedes usar las referencias de abajo si la primera no funciona bien.
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="repayment_down">

                                                <template v-if="offline_card_list && offline_card_list.length">
                                                    <template v-for="(item, index) in offline_card_list">

                                                        <div v-if="offline_card_list.length > 1" :key="index" class="repayment_ditems offline_card_listrepayment_dfrscale-1px">
                                                            <div class="repayment_ditem">
                                                                <div class="repayment_dititle">
                                                                    <template v-if="item.offline_card_title">
                                                                        {{item.offline_card_title}}
                                                                    </template>
                                                                    <template v-else> Reembolso de la tienda</template>
                                                                </div>
                                                                <div class="repayment_dmview">
                                                                    <div class="repayment_dmleft">
                                                                        <div class="repayment_dmlimg">
                                                                            <!--<img src="@/assets/mobimg/payment_711.png" alt="">-->
                                                                            <img :src="item.logo_pic" alt="">
                                                                        </div>
                                                                    </div>
                                                                    <div class="repayment_dmright">
                                                                        {{item.offline_des}}
                                                                    </div>
                                                                </div>
                                                                <div class="repayment_dfview">
                                                                    <div class="repayment_dfleft">Comisión<span>10 MAX</span></div>
                                                                    <div class="repayment_dfright">
                                                                        <span>q'e</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div v-else :key="index" class="repayment_ditems">
                                                            <div class="repayment_ditem">
                                                                <div class="repayment_dititle">
                                                                    <template v-if="item.offline_card_title">
                                                                        {{item.offline_card_title}}
                                                                    </template>
                                                                    <template v-else> Reembolso de la tienda</template>
                                                                </div>
                                                                <div class="repayment_dmview">
                                                                    <div class="repayment_dmleft">
                                                                        <div class="repayment_dmlimg">
                                                                            <!--<img src="@/assets/mobimg/payment_711.png" alt="">-->
                                                                            <img :src="item.logo_pic" alt="">
                                                                        </div>
                                                                    </div>
                                                                    <div class="repayment_dmright">
                                                                        {{item.offline_des}}
                                                                    </div>
                                                                </div>
                                                                <div class="repayment_dfview">
                                                                    <div class="repayment_dfleft">Comisión<span>{{item.handling_fee}} MAX</span></div>
                                                                    <div class="repayment_dfright" @click.stop="gotoOnlinePay(item)">
                                                                        <span>q'e</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </template>


                                                <!--<div class="repayment_ditems repayment_dfrscale-1px">
                                                    <div class="repayment_ditem">
                                                        <div class="repayment_dititle">Reembolso de la tienda</div>
                                                        <div class="repayment_dmview">
                                                            <div class="repayment_dmleft">
                                                                <div class="repayment_dmlimg">
                                                                    <img src="@/assets/mobimg/payment_711.png" alt="">
                                                                </div>
                                                            </div>
                                                            <div class="repayment_dmright">
                                                                También puedes pagar en el 7-ELEVEN, Farmacias del Ahorro, Walmart y otras tiendas...
                                                            </div>
                                                        </div>
                                                        <div class="repayment_dfview">
                                                            <div class="repayment_dfleft">Comisión<span>10 MAX</span></div>
                                                            <div class="repayment_dfright">
                                                                <span>q'e</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>-->

                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>


            <div id="repaymentonline" v-if="onlineShow">
                <van-popup v-model="onlineShow">
                    <div class="detail_wrap" style="width: 84vw;">
                        <div class="detail_cont">
                            <div class="detail_cview">
                                <div class="detail_cvtitle">
                                    Referencia de pago
                                </div>
                                <div class="detail_cvcopys">
                                    <div class="detail_cvcopy">
                                        <div class="detail_cvcopyleft">
                                            <span>{{code}}</span>
                                        </div>
                                        <div class="detail_cvcopyright" @click="copy(code)">Copiar</div>
                                    </div>
                                </div>
                                <div class="detail_cvqrccode">
                                    <div class="detail_cvqrccode_view">
                                        <svg id="barcode"></svg>
                                    </div>
                                </div>

                                <div class="detail_cvttitle">Monto designado</div>
                                <div class="detail_cvtamount">
                                    <div class="detail_cvtamitems">
                                        <div class="detail_cvtamileft">Pendiente de pago</div>
                                        <div class="detail_cvtamiright">$<span v-if="onlineinfo">{{onlineinfo.unpaid_amount}}</span></div>
                                    </div>
                                    <div class="detail_cvtamitems">
                                        <div class="detail_cvtamileft">Comisión</div>
                                        <div class="detail_cvtamiright">$<span v-if="onlineinfo">{{onlineinfo.handling_fee}}</span></div>
                                    </div>
                                </div>

                                <div class="detail_cvtamawran">
                                    <div class="repayment_mtthr">
                                        <div class="repayment_mtthr_cont detail_mtthr_cont">
                                            <div class="repayment_mtthr_cleft">
                                                <div class="repayment_mtthr_clicon">
                                                    <img src="@/assets/mobimg/online_warn_icon.png" alt="">
                                                </div>
                                            </div>
                                            <div class="repayment_mtthr_cright" v-if="onlineinfo">
                                                <!--{{onlineinfo.offline_des}}-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="detail_cview detail_cview_new" style="padding: 16px 0;" v-if="onlineinfo">
                                 <img :src="onlineinfo.support_type_pic" alt="">
                             </div>-->
                            <div class="detail_cvtitle_nres"></div>
                        </div>
                    </div>
                </van-popup>
            </div>

            <van-popup v-model="detailShow" position="bottom" round>
                <div class="verifycode_wrap">
                    <div class="verifycode_cont">
                        <div class="verifycode_tilte"></div>
                        <div class="verifycode_top verifycode_coupons_top">
                            <div class="verifycode_tleft">
                            <span>
                                Detalles del préstamo
                            </span>
                            </div>
                            <div class="verifycode_tright" @click="detailShow = false">
                                <img src="@/assets/mobimg/verifycode_tright.png" alt="">
                            </div>
                        </div>

                        <div class="redetail_coupons_form" v-if="repaymentInfo">
                            <div class="redetail_wrap">
                                <div class="redetail_title">
                                    <div class="redetail_tleft"></div>
                                    <div class="redetail_tright">Pedido</div>
                                </div>
                            </div>

                            <div class="redetail_cont" style="padding-top: 0.555556rem;">
                                <div class="confirmloan_msgitems">
                                    <div class="confirmloan_msgileft">Fecha del pago</div>
                                    <div class="confirmloan_msgiright">{{repaymentInfo.repay_time}}</div>
                                </div>
                                <div class="confirmloan_msgitems">
                                    <div class="confirmloan_msgileft">Monto de préstamo:</div>
                                    <div class="confirmloan_msgiright">$<span>{{repaymentInfo.loan_amount}}</span></div>
                                </div>
                                <div class="confirmloan_msgitems">
                                    <div class="confirmloan_msgileft">Interés</div>
                                    <div class="confirmloan_msgiright">$<span>{{repaymentInfo.interest}}</span></div>
                                </div>
                                <div class="confirmloan_msgitems">
                                    <div class="confirmloan_msgileft">Comisión</div>
                                    <div class="confirmloan_msgiright">$<span>{{repaymentInfo.service_fee}}</span></div>
                                </div>
                                <div class="confirmloan_msgitems">
                                    <div class="confirmloan_msgileft">IVA</div>
                                    <div class="confirmloan_msgiright">$<span>{{repaymentInfo.vat}}</span></div>
                                </div>
                                <div class="confirmloan_msgitems">
                                    <div class="confirmloan_msgileft">Monto del pago:</div>
                                    <div class="confirmloan_msgiright">$<span>{{repaymentInfo.total_amount_due}}</span></div>
                                </div>
                                <div class="confirmloan_msgitems">
                                    <div class="confirmloan_msgileft">Pagado parcial</div>
                                    <div class="confirmloan_msgiright">$<span>{{repaymentInfo.paid_amount}}</span></div>
                                </div>
                                <div class="confirmloan_msgitems">
                                    <div class="confirmloan_msgileft">Monto reducido</div>
                                    <div class="confirmloan_msgiright">$<span>{{repaymentInfo.reduced_amount}}</span></div>
                                </div>
                            </div>

                        </div>

                        <div class="verifycode_footer_btns">
                            <div class="verifycode_footer_btn">
                                <van-button round color="#00CA88" block @click="detailShow = false">
                                    <span style="font-weight: 500;">Enterado</span>
                                </van-button>
                            </div>
                        </div>

                    </div>
                </div>
            </van-popup>

            <van-popup v-model="cardShow" position="bottom" round>
                <div class="verifycode_wrap">
                    <div class="verifycode_cont">
                        <div class="verifycode_tilte"></div>
                        <div class="verifycode_top verifycode_coupons_top verifycode_coupons_top_new">
                            <div class="verifycode_tleft">
                            <span>
                                Plan de reembolso
                            </span>
                            </div>
                            <div class="verifycode_tright" @click="cardShow = false">
                                <img src="@/assets/mobimg/verifycode_tright.png" alt="">
                            </div>
                        </div>



                        <div class="recard_list">
                            <div class="recard_tite_wrap">
                                <div class="repayment_mtthr">
                                    <div class="repayment_mtthr_cont">
                                        <div class="repayment_mtthr_cleft">
                                            <div class="repayment_mtthr_clicon">
                                                <van-icon size="18" name="warning" color="#BDA170" />
                                            </div>
                                        </div>
                                        <div class="repayment_mtthr_cright repayment_mtthr_crtwo">
                                            Puedes usar las referencias de abajo si la primera no funciona bien.
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <template v-if="card_list && card_list.length">
                                <div class="recard_items" v-for="(item, index) in card_list" :key="index">
                                    <div class="recard_item_left">
                                        <span>{{item.card_no}}</span>
                                    </div>
                                    <div class="recard_item_right" @click="copy(item.card_no)"><span>Copiar</span></div>
                                </div>
                            </template>

                        </div>

                    </div>
                </div>
            </van-popup>

            <van-tabbar v-model="tabactive" active-color="#19A95C" inactive-color="#999999" @change="onTabChange">
                <van-tabbar-item icon="wap-home">Inicio</van-tabbar-item>
                <van-tabbar-item icon="contact">Yo</van-tabbar-item>
            </van-tabbar>
        </van-pull-refresh>
    </div>
</template>

<script type="text/javascript">

    import { getTimezoneName, getUserIp } from '@/utils/commonParams';
    import { loadingShow, loadingHide } from '@/utils/loading'
    import { getAccessToken } from '@/utils/auth';

    import { getLoanInfo, repaymentInfo } from '@/api/loan'

    import { Toast } from 'vant';
    import $ from 'jquery';
    import JsBarcode from 'jsbarcode'

    let apiHead = '';

    export default{
        data() {
            return {
                tabactive: 0,
                isInfoLoading: false,
                menusShow: false,
                changeNum: 50,
                sliderValue: 50,
                time: null,
                format: 'HH:mm:ss',
                loandetailshow: false,
                activeIndex: 1,
                repaymentInfo: null,
                card_val: null,
                onlineShow: false,
                code: 'sn12494932323333',
                onlineinfo: {
                    unpaid_amount: 100,
                    handling_fee: 20,
                },
                detailShow: false,
                cardShow: false,
                offline_card_list: [],
                couponsList: [],
                couponsObj: null,
                card_list: [],
            }
        },
        mounted() {
            this.countDown();
            this.getRepaymentInfo();
        },
        methods: {
            onRefresh() {
                this.isInfoLoading = true;
                this.gotoStatus();
            },
            onTabChange(item) {
                if(item == 0){
                    this.$router.replace({
                        path: '/loanpage/repayment'
                    })
                } else if(item == 1){
                    this.$router.push({
                        path: '/loanpage/usercenter'
                    })
                }
            },
            onHomeCenter() {
                //this.$router.back();
            },
            changeMode(index) {
                this.activeIndex = index;
                if(index == 2){
                    this.onlineShow = true;

                    this.$nextTick(() => {
                        let options = {
                            widht: 100,
                            height: 70,
                            background: 'rgba(255,255,255,.0)',
                        };

                        let repay_code = this.code;

                        JsBarcode('#barcode', repay_code, options)
                    });

                }
            },
            onClosePayment() {
                this.loandetailshow = false;
            },
            onShowLoanDetail() {
                this.loandetailshow = true;
            },
            onHomeConfirm() {
                console.log('前往登录')
                let login_token = window.localStorage.getItem('login_token');
                if(login_token){ //已经登录
                    console.log('已登录11111')
                } else { //未登录
                    console.log('未登录1111')
                    this.gotoLogin();
                }
            },
            onCloseMeuns() {
                this.menusShow = false;
            },
            onHomeMenus() {
                this.menusShow = true;
            },
            countDown() { // 传入时间戳
                const d = new Date('2025-07-6').getTime()
                if(d && d != 0){
                    const now = new Date().getTime();
                    let timeStamp = d - now;

                    console.log(timeStamp)
                    this.time = timeStamp;
                }
            },
            dealNumber(num) {
                if (num != 0 && num) {
                    num = num + "";
                    let splitList = num.split(".");
                    //将整数部分拆解为单个数字的数组倒序，然后拼装为新的数组，每3位数字进行一次匹配
                    let intStrList = splitList[0]
                        .split("")
                        .reverse()
                        .join("")
                        .match(/(\d{1,3})/g);
                    //将匹配后的数组用，拼接，再拆解为单个数字的数组，反转为原先数组形式，拼接为完整数字
                    let intStr = intStrList.join(",").split("").reverse().join("");
                    return intStr;
                }
                return num;
            },
            copy(value) {
                var domUrl = document.createElement("input");
                domUrl.value = value;
                domUrl.id = "creatDom";
                document.body.appendChild(domUrl);
                domUrl.select(); // 选择对象
                document.execCommand("Copy"); // 执行浏览器复制命令
                let creatDom = document.getElementById("creatDom");
                creatDom.parentNode.removeChild(creatDom);
                this.$toast("Copia con éxito");
                return;
            },
            async getRepaymentInfo() {
                console.log('前往登录')
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                    };

                    let headerParams = {
                        'ad-justad-id': localStorage.getItem("adjust_id"),
                        'ad-justad-j': '',
                        'ad-justad-idfv': '',
                    };

                    repaymentInfo(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip,
                        ...headerParams
                    }).then(res => {
                        console.log(res)
                        loadingHide()
                        this.isInfoLoading = false;
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                let repaymentInfo = useDataJSON.info;
                                console.log(repaymentInfo)
                                this.repaymentInfo = repaymentInfo;

                                let card_list = repaymentInfo.card_list;
                                let offline_card_list = [];

                                if(card_list && card_list.length){
                                    this.card_val = card_list[0].card_no
                                }



                                this.card_list = card_list;
                                this.offline_card_list = offline_card_list;
                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        this.isInfoLoading = false;
                        loadingHide()
                    });


                } else { //未登录
                    console.log('未登录1111')
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })
                }
            },
            async gotoStatus() {
                let _this = this;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                    };

                    let headerParams = {
                        'ad-justad-id': localStorage.getItem("adjust_id"),
                        'ad-justad-j': '',
                        'ad-justad-idfv': '',
                    };

                    loadingShow();
                    getLoanInfo(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip,
                        ...headerParams
                    }).then(res => {
                        console.log(res)
                        loadingHide()
                        this.isInfoLoading = false;
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                let { vkt_fnd_yzo, ojq_dzg_oxq } = useDataJSON;
                                //order_status, reapply_time, current_is_reloan,
                                let { omi_fje_qly, huw_kdq_nxo, xhi_cur_ovl } = vkt_fnd_yzo;

                                console.log(omi_fje_qly);
                                console.log(huw_kdq_nxo);
                                console.log(ojq_dzg_oxq);
                                console.log(xhi_cur_ovl);

                                //               order_status, reapply_time, server_time, current_is_reloan,
                                //this.getStatus(omi_fje_qly, huw_kdq_nxo, ojq_dzg_oxq, xhi_cur_ovl, _this);

                                this.getStatus(omi_fje_qly, huw_kdq_nxo, ojq_dzg_oxq, xhi_cur_ovl, _this);

                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                        //this.isInfoLoading = false;
                    });
                } else { //未登录
                    console.log('未登录1111')
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })
                    //this.gotoLogin();
                }
            },
            getStatus: (value, reapply_time, server_time, current_is_reloan, _this) => {
                switch (value) {
                    case 0:
                    case 10:
                    case 15:
                    case 17:
                    case 21:
                        console.log('0没有申请过,10失效,15展期结清,17展期失效,21等待签约');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = null;
                            }
                        } else {
                            _this.isReloan = null;
                        }

                        if(_this.isReloan == 1){
                            _this.$router.replace({
                                path: '/loanpage/reapeatloan'
                            });
                        } else {
                            _this.$router.replace({
                                path: '/loanpage/applyhome'
                            });
                        }
                        break;
                    case 1:
                    case 2:
                    case 4:
                    case 13:
                    case 18:
                    case 19:
                    case 20:
                        console.log('//1提交申请,2提交审核,4等待人工审核,17展期失效,21等待签约');
                        _this.orderStatus = 1;
                        _this.loanStatus = 1;
                        _this.status = 1;
                        _this.$router.replace({
                            path: '/loanpage/loanstatus'
                        });
                        break;
                    case 3:
                        console.log('//审核拒绝');
                        if (_this.canReloanByTime(reapply_time, server_time)) {
                            _this.orderStatus = 2;
                            /*if (_this.isReloan) {
                                if(current_is_reloan != undefined){
                                    if(current_is_reloan == 1){
                                        _this.isReloan = 1;
                                    } else {
                                        _this.isReloan = 1;
                                    }
                                } else {
                                    _this.isReloan = 1;
                                }
                                _this.$router.replace({
                                    path: '/loanpage/reapeatloan'
                                });
                            } else {

                            }*/

                            if(current_is_reloan != undefined){
                                if(current_is_reloan == 1){
                                    _this.isReloan = 1;
                                } else {
                                    _this.isReloan = null;
                                }
                            } else {
                                _this.isReloan = null;
                            }

                            if(_this.isReloan == 1){
                                _this.$router.replace({
                                    path: '/loanpage/reapeatloan'
                                });
                            } else {
                                _this.$router.replace({
                                    path: '/loanpage/applyhome'
                                });
                            }

                        } else {
                            _this.orderStatus = 1;
                            _this.loanStatus = 2;
                            _this.status = 2;

                            if(_this.isReloan == 1){
                                _this.$router.replace({
                                    path: '/loanpage/reapeatloan'
                                });
                            } else {
                                _this.$router.replace({
                                    path: '/loanpage/applyhome'
                                });
                            }
                        }
                        break;
                    case 5:
                    case 12:
                        console.log('//5等待放款，12正在放款中');
                        _this.orderStatus = 1;
                        _this.loanStatus = 3;
                        _this.status = 3;
                        _this.$router.replace({
                            path: '/loanpage/loanstatus'
                        });
                        break;
                    case 6:
                        console.log('//放款失败');
                        _this.orderStatus = 1;
                        _this.loanStatus = 4;
                        _this.status = 4;
                        _this.$router.replace({
                            path: '/loanpage/loanstatus'
                        });
                        break;
                    case 7:
                    case 9:
                    case 11:
                    case 14:
                    case 16:
                        console.log('7等待还款，9逾期，11部分还款，14等待展期，16展期申请中');
                        _this.orderStatus = 3;
                        loadingShow();
                        _this.getRepaymentInfo();
                        break;
                    case 8:
                        console.log('8已结清');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = 1;
                            }
                        } else {
                            _this.isReloan = 1;
                        }
                        _this.$router.replace({
                            path: '/loanpage/reapeatloan'
                        });
                        break;
                    case 22:
                        console.log('22等待订单再次确认, 此处掉用确认放款');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = 0;
                            }

                        } else {
                            _this.isReloan = 0;
                        }

                        _this.$router.replace({
                            path: '/loanpage/firstloan'
                        });

                        break;
                    default:
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = null;
                            }
                        } else {
                            _this.isReloan = null;
                        }

                        if(_this.isReloan == 1){
                            _this.$router.replace({
                                path: '/loanpage/reapeatloan'
                            });
                        } else {
                            _this.$router.replace({
                                path: '/loanpage/applyhome'
                            });
                        }
                }
            },
            canReloanByTime(repTime, stime) {
                return repTime < stime;
            },
        }
    }

</script>

<style scoped>
    .audithome_wrap{
        width: 100%;
        height: 9.861111rem;
        background: linear-gradient(180deg, #19A95C 0%, #F6F6F6 100%);
    }
    .audithome_head{
        width: 100%;
        height: 1.333333rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0 0.444444rem;
    }
    .audithome_hleft{
        width: 5.555556rem;
        height: 0.583333rem;
        font-size: 0.5rem;
        font-weight: 500;
        color: #FFFFFF;
    }
    .audithome_hright{
        width: 1.361111rem;
        height: 0.5rem;
        display: flex;
        justify-content: space-between;
    }
    .audithome_hrimg{
        width: 0.5rem;
        height: 0.5rem;
    }
    .audithome_hrimg img{
        display: block;
        width: 0.5rem;
        height: 0.5rem;
    }
    .audithome_tps{
        width: 100%;
        height: 0.833333rem;
        box-sizing: border-box;
        /* background: rgba(255,255,255,0.26);*/
        margin-top: 6px;
    }
    .audithome_tps span{
        width: 100%;
        height: 0.388889rem;
        font-size: 12px;
        font-weight: 400;
        color: #FFFFFF;
        transform: scale(0.9);
        transform-origin:0 0;
        overflow: hidden;
        white-space:nowrap;
        -o-text-overflow:ellipsis;
        text-overflow:ellipsis;
    }
    #firstloan{
        /*padding-bottom: 30px;*/
    }
    #firstloan .audithome_cont{
        width: 100%;
        height: 8.9rem;
        position: relative;
    }
    #firstloan  .audithome_cview{
        width: 100%;
        height: auto;
        position: absolute;
        left: 0;
        top: -7.694444rem;
    }
    #firstloan  .auditpass_wrap{
        width: 100%;
        height: auto;
        position: relative;
    }
    #firstloan .auditpass_bgimg{
        display: block;
        width: 100%;
    }
    #firstloan .audithome_cont .auditpass_view{
        width: 100%;
        height: auto;
        position: absolute;
        left: 0;
        top: 0;
        box-sizing: border-box;
        padding-top: 4.222222rem;
    }
    #firstloan .auditpass_title{
        width: 100%;
        height: 0.972222rem;
        font-size: 0.583333rem;
        font-weight: bold;
        color: #333333;
        line-height: 0.583333rem;
        text-align: center;
    }
    #firstloan .auditpass_desc{
        width: 92.22%;
        height: auto;
        margin: 0 auto;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #666666;
        line-height: 0.472222rem;
        text-align: center;
    }
    #firstloan .auditpass_solid_view{
        width: 100%;
        height: 0.388889rem;
        margin-top: 4.25rem;
        box-sizing: border-box;
        padding: 0 0.444444rem;
        display: flex;
        justify-content: space-between;
    }
    #firstloan .auditpass_solid_middle{
        width: auto;
        height: 0.388889rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #19A95C;
        line-height: 0.388889rem;
    }
    #firstloan .auditpass_solid_left{
        width: 2.916667rem;
        height: 0.388889rem;
        display: flex;
        align-items: center;
    }
    #firstloan .auditpass_solid_left img{
        display: block;
        width: 100%;
        height: 1px;
    }
    #firstloan .auditpass_solid_right{
        width: 2.916667rem;
        height: 0.388889rem;
        display: flex;
        align-items: center;
    }
    #firstloan .auditpass_solid_right img{
        display: block;
        width: 100%;
        height: 1px;
    }
    #firstloan .auditpass_btns{
        width: 92.22%;
        height: 1.222222rem;
        margin: 0 auto;
    }

    #firstloan_head .audithome_cont{
        width: 100%;
        height: 6.861111rem;
        position: relative;
    }
    #firstloan_head .audithome_cview{
        width: 100%;
        height: 14.555556rem;
        position: absolute;
        left: 0;
        top: -7.694444rem;
    }
    #firstloan_head .auditpass_wrap{
        width: 100%;
        height: auto;
        position: relative;
    }
    #firstloan_head .auditpass_bgimg{
        display: block;
        width: 100%;
    }
    #firstloan_head .audithome_cont .auditpass_view{
        width: 100%;
        height: auto;
        position: absolute;
        left: 0;
        top: 0;
        box-sizing: border-box;
        padding-top: 4.222222rem;
    }
    #firstloan_head .auditpass_title{
        width: 100%;
        height: 0.972222rem;
        font-size: 0.583333rem;
        font-weight: bold;
        color: #333333;
        line-height: 0.583333rem;
        text-align: center;
    }
    #firstloan_head .auditpass_desc{
        width: 92.22%;
        height: auto;
        margin: 0 auto;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #666666;
        line-height: 0.472222rem;
        text-align: center;
    }
    #firstloan_head .auditpass_solid_view{
        width: 100%;
        height: 0.388889rem;
        margin-top: 4.25rem;
        box-sizing: border-box;
        padding: 0 0.444444rem;
        display: flex;
        justify-content: space-between;
    }
    #firstloan_head .auditpass_solid_middle{
        width: auto;
        height: 0.388889rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #19A95C;
        line-height: 0.388889rem;
    }
    #firstloan_head .auditpass_solid_left{
        width: 2.916667rem;
        height: 0.388889rem;
        display: flex;
        align-items: center;
    }
    #firstloan_head .auditpass_solid_left img{
        display: block;
        width: 100%;
        height: 1px;
    }
    #firstloan_head .auditpass_solid_right{
        width: 2.916667rem;
        height: 0.388889rem;
        display: flex;
        align-items: center;
    }
    #firstloan_head .auditpass_solid_right img{
        display: block;
        width: 100%;
        height: 1px;
    }
    #firstloan_head .auditpass_times{
        width: 100%;
        height: 0.833333rem;
        display: flex;
        align-items: center;
    }
    #firstloan_head .zpan_hthr_times{
        width: auto;
        height: 0.694444rem;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
    }
    #firstloan_head .zpan_hthr_ditmes_day {
        width: auto;
        height: 0.694444rem;
        line-height: 0.694444rem;
        font-size: 12px;
        color: #333333;
        font-weight: bold;
        padding: 0 2px;
    }
    #firstloan_head .zpan_hthr_titmes{
        width: 0.694444rem;
        height: 0.694444rem;
        background: #ffffff;
        border-radius: 0.083333rem;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        border: 1px solid #BCDCCA;
    }
    #firstloan_head .zpan_hthr_titmes span{
        width: 100%;
        font-size: 0.388889rem;
        font-weight: 600;
        color: #19A95C;
        text-align: center;
    }
    #firstloan_head .zpan_hthr_ditmes{
        width: 0.388889rem;
        height: 0.583333rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    #firstloan_head .auditpass_btns{
        width: 92.22%;
        height: 1.222222rem;
        margin: 0 auto;
    }
    #firstloan_head{
        padding-bottom: 30px;
    }
    .audithome_tps_text{
        width: 100%;
        color: #333333;
        font-size: 14px;
        font-weight: bold;
        line-height: 0.72rem;
        text-align: left;
        box-sizing: border-box;
        padding: 0 16px;
    }
    .firstloan_amount{
        width: 100%;
        height: auto;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
        padding: 20px 0.416667rem 0 0.416667rem;
    }
    .firstloan_amount_left{
        width: 60%;
        height: auto;
    }
    .firstloan_amount_right{
        width: 40%;
        height: auto;
    }
    .firstloan_amount_title{
        width: 100%;
        height: auto;
        font-size: 16px;
        color: #333333;
    }
    .firstloan_amount_days{
        font-size: 1.0rem;
    }
    .firstloan_amount_days span{
        font-size: 1.2rem;
    }
    .confirmloan_cmview {
        width: 100%;
        height: auto;
    }
    .confirmloan_cmview .itoken_check_vitleft {
        color: #808080;
    }
    .confirmloan_cmitems {
        width: 100%;
        height: 1.277778rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .confirmloan_cmileft {
        width: auto;
        height: auto;
        font-size: 14px;
        font-weight: 400;
        color: #69706e;
    }
    .confirmloan_cmiright {
        width: auto;
        height: auto;
        font-size: 14px;
        font-weight: 400;
        color: #303332;
    }
    .confirmloan_cmview .itoken_check_vitems {
        padding-top: 0.444444rem;
        padding-bottom: 0.444444rem;
    }
    .itoken_checkvi_scale-1px {
        position: relative;
        border: none;
    }
    .itoken_checkvi_scale-1px:after {
        content: '';
        position: absolute;
        bottom: 0;
        background: #dfdcdc;
        width: 100%;
        height: 1px;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
    }
    ..itoken_check_vitem {
        width: 100%;
        height: auto;
    }
    .itoken_check_vitop {
        width: 100%;
        height: 14px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .itoken_check_vitleft {
        width: auto;
        height: 14px;
        font-size: 14px;
        font-weight: 400;
        color: #1a1a1a;
    }
    .itoken_check_vitright {
        width: auto;
        height: 14px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 2px;
    }
    .itoken_check_vitrnums {
        width: auto;
        height: 14px;
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 500;
        color: #1a1a1a;
    }
    .itoken_check_vitrnums span {
        font-size: 14px;
        font-weight: 500;
        color: #1a1a1a;
        padding-right: 4px;
    }
    .itoken_check_vitrarrow {
        width: 14px;
        height: 14px;
        margin-left: 4px;
    }
    .itoken_check_vitrarrow img {
        display: block;
        width: 100%;
    }
    .itoken_check_vitleft_coupon {
        width: auto;
        height: 14px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .itoken_check_vitleft_coupon span {
        font-size: 14px;
        font-weight: 400;
        color: #69706e;
    }
    .confirmloan_cmcontrato_wrap {
        width: 100%;
        height: auto;
        padding: 11px 0 49px 0;
    }
    .confirmloan_cmcontrato_cont {
        width: 100%;
        height: 24px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .confirmloan_cmcontrato_cleft {
        width: auto;
        height: 24px;
        display: flex;
        align-items: center;
    }
    .confirmloan_cmcontrato_cleft img {
        display: block;
        width: 24px;
        height: 24px;
    }
    .itoken_check_vitems_details {
        width: 100%;
        height: auto;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-bottom: 1.333333rempx;
    }
    .itoken_check_vitems_detail {
        width: 100%;
        height: auto;
        background: #f4f5f4;
        border-radius: 8px;
        box-sizing: border-box;
        padding: 7px 14px;
    }
    .confirmloan_msgitems {
        width: 100%;
        height: 0.75rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .confirmloan_msgileft {
        width: auto;
        height: 13px;
        font-size: 13px;
        font-weight: 400;
        color: #69706e;
        line-height: 13px;
    }
    .confirmloan_msgiright {
        width: auto;
        height: 13px;
        font-size: 13px;
        font-weight: 500;
        color: #69706e;
        line-height: 13px;
    }
    .confirmloan_msgiright span {
        padding-left: 10px;
    }
    .confirmloan_msgiright .delete__line{
        text-decoration: line-through;
    }
    .firstloan_loantitle{
        width: 100%;
        height: auto;
        font-size: 18px;
        color: #333333;
        font-weight: bold;
    }
    .verifycode_wrap{
        width: 100%;
        height: auto;
    }
    .verifycode_cont{
        width: 100%;
        height: auto;
        background: #FFFFFF;
        border-radius: 0.555556rem 0.555556rem 0px 0px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-top: 0.222222rem;
    }
    .verifycode_tilte{
        width: 1.25rem;
        height: 0.083333rem;
        background: #CFCFCF;
        border-radius: 0.083333rem;
        margin: 0 auto;
    }
    .verifycode_top{
        width: 100%;
        height: 1.7rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 0.555556rem 0.444444rem 0 0.444444rem;
        display: flex;
        justify-content: space-between;
    }
    .verifycode_tleft{
        width: auto;
        height: 0.611111rem;
        font-size: 0.527778rem;
        font-weight: bold;
        color: #1A1A1A;
        line-height: 44px;
        display: flex;
        align-items: center;
    }
    .verifycode_tleft span{
        float: left
    }
    .verifycode_tright{
        width: 0.666667rem;
        height: 0.666667rem;
    }
    .verifycode_tright img{
        display: block;
        width: 100%;
    }
    .mode_view{
        width: 100%;
        height: auto;
        position: relative;
        top: -10px;
    }
    .mode {
        padding: 16px;
        background: #ffffff;
        border-radius: 10px;
    }
    .mode__tabs {
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding-bottom: 13px;
    }
    .mode__tabs__item {
        font-size: 14px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #333333;
        line-height: 17px;
        position: relative;
    }
    .mode__tabs__line {
        width: 1px;
        height: 20px;
        background: #f5f5f5;
    }
    .mode__tabs-bottom-border {
        border-bottom: 1px solid #f5f5f5;
        box-shadow: 0px 1px 3px 0px rgba(210, 211, 213, 0.34);
        margin-bottom: 16px;
    }
    .active {
        font-family: Roboto-Medium, Roboto;
        color: #006747;
        font-weight: 500;
    }
    .active:after {
        content: '';
        display: block;
        width: 40px;
        height: 3px;
        background: #006747;
        position: absolute;
        bottom: -15px;
        left: calc(50% - 20px);
    }
    .mode__offline-amount {
        font-size: 12px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 600;
        color: #69706e;
        line-height: 13px;
        margin: 8px 0;
    }
    .card {
        background: #f7f8f8;
        border-radius: 10px;
        margin-bottom: 12px;
        padding: 12px;
    }
    .mode-des {
        font-size: 12px;
        font-family: Roboto-Regular, Roboto;
        color: #a8aaa9;
        line-height: 12px;

    }
    .mode-des span {
        font-family: Roboto Bold;
    }
    .mode-logo {
        width: 40px;
        height: 40px;
    }
    .mode-btn {
        padding: 6px 15px;
        background: #006747;
        border-radius: 15px;
        font-size: 13px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #ffffff;
        line-height: 13px;
    }
    .card:nth-last-of-type(1) {
        margin-bottom: 0;
    }
    .flex-between {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .mr-b-16 {
        margin-bottom: 16px;
    }
    .repayment_middle{
        width: 100%;
        height: auto;
        background: #FFFFFF;
        border-radius: 0.333333rem;
    }
    .repayment_mtop{
        width: 100%;
        height: auto;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 0.083333rem 0.083333rem 0.083333rem 0.083333rem;
    }
    .repayment_mtview{
        width: 100%;
        height: 5.361111rem;
        background: linear-gradient(270deg, #FFF1D7 0%, #FFF7E9 100%);
        border-radius: 0.277778rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 0.166667rem 0.361111rem 0.555556rem 0.361111rem;
    }
    .repayment_mttitle{
        width: 100%;
        height: 1.055556rem;
        font-size: 0.444444rem;
        font-weight: 500;
        color: #1A1A1A;
        line-height: 1.055556rem;
    }
    .repayment_mtone{
        width: 100%;
        height: 1.527778rem;
    }
    .repayment_mtone_cont{
        width: 100%;
        height: 1.111111rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .repayment_mtonecleft{
        width: 1.111111rem;
        height: 1.111111rem;
    }
    .repayment_mtonecright{
        width: 5.222222rem;
        height: 0.833333rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        border: 1px solid #D5C6AB;
        border-radius: 0.111111rem;
        padding: 0 0.277778rem 0 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .repayment_mtonecr_cont{
        width: 4.166667rem;
        height: 0.833333rem;
        display: flex;
        align-items: center;
        position: relative;
    }
    .repayment_mtonecr_cont input{
        display: block;
        width: 100%;
        height: 0.666667rem;
        border: 0;
        outline: none;
        background: none;
        padding-left: 0.3rem;
        font-size: 12px;
        font-weight: 500;
        color: #1A1A1A;
        line-height: 0.666667rem;
    }
    .repayment_mtonecr_dv{
        width: 4.166667rem;
        height: 0.833333rem;
        position: absolute;
        left: 0;
        top: 0;
    }
    .repayment_mtonecr_icon{
        width: 0.277778rem;
        height: 0.277778rem;
    }
    .repayment_mtonecr_icon img{
        display: block;
        width: 100%;
        height: 100%;
    }
    .repayment_mttwo{
        width: 100%;
        height: 1.361111rem;
    }
    .repayment_mttwo_cont{
        width: 100%;
        height: 0.833333rem;
        display: flex;
        justify-content: space-between;
    }
    .repayment_mttwo_cleft{
        width: auto;
        height: 0.833333rem;
        font-size: 12px;
        font-weight: 500;
        color: #343E3A;
        line-height: 0.833333rem;
    }
    .repayment_mttwo_cleft span{
        font-weight: bold;
        color: #DB861F;
    }
    .repayment_mttwo_cright{
        width: 1.888889rem;
        height: 0.833333rem;
        background: #00CA88;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 0.416667rem;
    }
    .repayment_mttwo_cright span{
        font-size: 13px;
        font-weight: 500;
        color: #FFFFFF;
    }
    .repayment_mtthr{
        width: 100%;
        height: auto;
    }
    .repayment_mtthr_cont{
        width: 100%;
        height: auto;
        display: flex;
        justify-content: flex-start;
    }
    .repayment_mtthr_cleft{
        width: 0.833333rem;
        height: 0.833333rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .repayment_mtthr_clicon{
        width: 14px;
        height: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .repayment_mtthr_cright{
        width: auto;
        font-size: 11px;
        font-weight: 500;
        color: #808080;
        line-height: 0.416667rem;
        box-sizing: border-box;
    }
    .repayment_mtthr_crtwo{
        color: #BDA170;
    }
    .repayment_down{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0 0.444444rem 0 0.444444rem;
        background: #ffffff;
        border-radius: 0.333333rem;
    }
    .repayment_ditems{
        width: 100%;
        height: 4.083333rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-top: 0.25rem;
    }
    .repayment_ditem{
        width: 100%;
        height: auto;
    }
    .repayment_dititle{
        width: 100%;
        height: 1.055556rem;
        font-size: 0.444444rem;
        font-weight: 500;
        color: #1A1A1A;
        line-height: 1.055556rem;
    }
    .repayment_dmview{
        width: 100%;
        height: 1.388889rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .repayment_dmleft{
        width: 1.111111rem;
        height: 1.388889rem;
    }
    .repayment_dmlimg{
        width: 1.111111rem;
        height: 1.111111rem;
    }
    .repayment_dmlimg img{
        display: block;
        width: 1.111111rem;
        height: 1.111111rem;
    }
    .repayment_dmright{
        width: 5.222222rem;
        font-size: 11px;
        font-weight: 500;
        color: #808080;
        line-height: 0.416667rem;
    }
    .repayment_dfview{
        width: 100%;
        height: 0.833333rem;
        display: flex;
        justify-content:space-between;
        align-items: center;
    }
    .repayment_dfleft{
        width: auto;
        font-size: 12px;
        font-weight: 500;
        color: #343E3A;
        line-height: 12px;
    }
    .repayment_dfleft span{
        padding-left: 0.083333rem;
        color: #DB861F
    }
    .repayment_dfright{
        width: 1.888889rem;
        height: 0.833333rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        border: 1px solid #00CA88;
        border-radius: 0.416667rem;
        font-size: 0.361111rem;
        font-weight: 500;
        color: #00CA88;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    /* 1px边框 底部*/
    .repayment_dfrscale-1px{
        position: relative;
        border:none;
    }
    .repayment_dfrscale-1px:after{
        content: '';
        position: absolute;
        bottom: 0;
        background: #E6E9E8;
        width: 100%;
        height: 1px;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
    }

    .detail_wrap{
        width: 100%;
        height: auto;
        background: #F6F6F6 url(../../assets/mobimg/detail_banner.png) no-repeat top right;
        background-size: 100%;
        border-radius: 10px;
    }
    .detail_cont{
        width: 100%;
        height: auto;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 0.555556rem 0.444444rem 0 0.444444rem;
    }
    .detail_cview{
        width: 100%;
        height: auto;
        background: #FFFFFF;
        border-radius: 0.333333rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 0 0.444444rem 0.444444rem 0.444444rem;
    }
    .detail_cvtitle{
        width: 100%;
        height: 1.888889rem;
        font-size: 0.444444rem;
        font-weight: 500;
        color: #343E3A;
        line-height: 1.555556rem;
    }
    .detail_cvcopys{
        width: 100%;
        height: 1.388889rem;
    }
    .detail_cvcopy{
        width: 100%;
        height: 0.833333rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #F6F6F6;
        border-radius: 0.416667rem;
    }
    .detail_cvcopyleft{
        width: 6.333333rem;
        height: 0.833333rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-left: 0.444444rem;
        display: flex;
        align-items: center;
    }
    .detail_cvcopyleft span{
        font-size: 0.388889rem;
        font-weight: 500;
        color: #343E3A;
    }
    .detail_cvcopyright{
        width: 1.888889rem;
        height: 0.833333rem;
        background: #00CA88;
        border-radius: 0.416667rem;
        font-size: 0.361111rem;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 0.833333rem;
        text-align: center;
    }
    .detail_cvqrccode{
        width: 100%;
        height: auto;
        min-height: 1.555556rem;
        display: flex;
        justify-content: center;
        overflow: hidden;
    }
    .detail_cvqrccode_view{
        display: inline-block;
        width: auto;
        height: auto;
    }
    #barcode {
        margin: 0 auto;
    }
    .detail_cvttitle{
        width: 100%;
        height: 1.111111rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-top: 0.444444rem;
        font-size: 0.444444rem;
        font-weight: 500;
        color: #343E3A;
        line-height: 0.666667rem;
    }
    .detail_cvtamount{
        width: 100%;
        height: auto;
        padding-top: 0.444444rem;
    }
    .detail_cvtamitems{
        width: 100%;
        height: 0.833333rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .detail_cvtamileft{
        width: auto;
        font-size: 0.388889rem;
        font-weight: 500;
        color: #808080;
    }
    .detail_cvtamiright{
        width: auto;
        font-size: 0.388889rem;
        font-weight: 500;
        color: #343E3A;
    }
    .detail_cvtamiright span{
        padding-left: 0.083333rem;
    }
    .detail_cvtamawran{
        width: 100%;
        margin-top: 0.666667rem;
        background: #F6F6F6;
        border-radius: 0.277778rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 0.222222rem 0.444444rem 0.222222rem 0.222222rem;
    }
    .detail_cvtamawran .repayment_mtthr_cleft{
        width: 0.666667rem;
        height: 100%;
    }
    .detail_cvtamawran .repayment_mtthr_clicon{
        width: 0.666667rem;
        height: 0.666667rem;
        background: #F6F6F6;
    }
    .detail_mtthr_cont{
        align-items: center;
    }
    .detail_cvtamawran .repayment_mtthr_cright{
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-left: 0.111111rem;
    }
    .repayment_wrap{
        width: 100%;
        height: auto;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 0 0.444444rem 3.222222rem 0.444444rem;
    }
    .repayment_cont{
        width: 100%;
        height: auto;
    }
    .repayment_head{
        width: 100%;
        height: 1.444444rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .repayment_hleft{
        width: auto;
        height: 0.555556rem;
        font-size: 0.444444rem;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 0.555556rem;
    }
    .repayment_hright{
        width: auto;
        height: 0.555556rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .repayment_hrtext{
        width: auto;
        height: 0.555556rem;
        font-size: 0.388889rem;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 0.555556rem;
        padding-right: 0.111111rem;
    }
    .repayment_hricon{
        width: 0.277778rem;
        height: 0.277778rem;
    }
    .repayment_hricon img{
        display: block;
        width: 100%;
    }
    .repayment_amount{
        width: 100%;
        height: 1.222222rem;
        font-size: 1.111111rem;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 1.111111rem;
        display: flex;
        justify-content: flex-start;
    }
    .repayment_amount span{
        font-size: 0.611111rem;
        padding-right: 0.111111rem;
    }
    .repayment_amount_two{
        color: #FFE574;
    }
    .repayment_amview{
        width: 2.083333rem;
        height: 1.222222rem;
        position: relative;
    }
    .repayment_amvimg{
        width: 1.833333rem;
        height: 0.583333rem;
        position: absolute;
        left: 0.25rem;
        top: -0.305556rem;
        background: url(../../assets/mobimg/repayment_amvimg.png) no-repeat top right;
        background-size: 100%;
        font-size: 12px;
        font-weight: 500;
        color: #957900;
        line-height: 0.583333rem;
        text-align: center;
    }
    .repayment_times{
        width: 100%;
        height: 0.9rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .repayment_times div{
        width: auto;
        height: 20px;
        font-size: 13px;
        font-weight: 500;
        color: #FFFFFF;
    }
    .repayment_times span{
        display: block;
        width: auto;
        height: 20px;
        font-size: 13px;
        color: #FFE574;
        font-weight: bold;
        padding-left: 0.2rem;
        line-height: 20px;
    }
    .repayment_coupons{
        width: 100%;
        min-height: 1.111111rem;
        margin: 0.277778rem auto 0.444444rem auto;
        /* background: #15E59D url(../../assets/mobimg/repayment_bgimg01.png) no-repeat top right;
         background-size: 100%;*/
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 0 0.444444rem 0.333333rem 0.444444rem;
        border-radius: 0.277778rem;
        background: #15E59D;
    }
    .repayment_coupons_view{
        width: 100%;
        height: auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 0.333333rem;
    }
    .repayment_cupsleft{
        width: auto;
        height: 0.444444rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .repayment_cupslicon{
        width: 0.444444rem;
        height: 0.444444rem;
    }
    .repayment_cupslicon img{
        display: block;
        width: 100%;
    }
    .repayment_cupsltext{
        width: auto;
        height: 0.444444rem;
        font-size: 0.361111rem;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 0.444444rem;
        padding-left: 0.166667rem;
    }
    .repayment_cupsright{
        width: auto;
        height: 0.444444rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .repayment_cupsrtext{
        width: auto;
        font-size: 0.361111rem;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 0.361111rem;
        padding-right: 2px;
    }
    .repayment_cupsrtext span{
        padding-right: 0.083333rem;
    }
    .repayment_cupsricon{
        width: 0.277778rem;
        height: 0.277778rem;
    }
    .repayment_cupsricon img{
        display: block;
        width: 100%;
    }
    .repayment_middle{
        width: 100%;
        height: auto;
        background: #FFFFFF;
        border-radius: 0.333333rem;
    }
    .repayment_mtop{
        width: 100%;
        height: auto;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 0.083333rem 0.083333rem 0.083333rem 0.083333rem;
    }
    .repayment_mtview{
        width: 100%;
        height: 5.361111rem;
        background: linear-gradient(270deg, #FFF1D7 0%, #FFF7E9 100%);
        border-radius: 0.277778rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 0.166667rem 0.361111rem 0.555556rem 0.361111rem;
    }
    .repayment_mttitle{
        width: 100%;
        height: 1.055556rem;
        font-size: 0.444444rem;
        font-weight: 500;
        color: #1A1A1A;
        line-height: 1.055556rem;
    }
    .repayment_mtone{
        width: 100%;
        height: 1.527778rem;
    }
    .repayment_mtone_cont{
        width: 100%;
        height: 1.111111rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .repayment_mtonecleft{
        width: 1.111111rem;
        height: 1.111111rem;
    }
    .repayment_mtonecright{
        width: 5.222222rem;
        height: 0.833333rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        border: 1px solid #D5C6AB;
        border-radius: 0.111111rem;
        padding: 0 0.277778rem 0 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .repayment_mtonecr_cont{
        width: 4.166667rem;
        height: 0.833333rem;
        display: flex;
        align-items: center;
        position: relative;
    }
    .repayment_mtonecr_cont input{
        display: block;
        width: 100%;
        height: 0.666667rem;
        border: 0;
        outline: none;
        background: none;
        padding-left: 0.3rem;
        font-size: 12px;
        font-weight: 500;
        color: #1A1A1A;
        line-height: 0.666667rem;
    }
    .repayment_mtonecr_dv{
        width: 4.166667rem;
        height: 0.833333rem;
        position: absolute;
        left: 0;
        top: 0;
    }
    .repayment_mtonecr_icon{
        width: 0.277778rem;
        height: 0.277778rem;
    }
    .repayment_mtonecr_icon img{
        display: block;
        width: 100%;
        height: 100%;
    }
    .repayment_mttwo{
        width: 100%;
        height: 1.361111rem;
    }
    .repayment_mttwo_cont{
        width: 100%;
        height: 0.833333rem;
        display: flex;
        justify-content: space-between;
    }
    .repayment_mttwo_cleft{
        width: auto;
        height: 0.833333rem;
        font-size: 12px;
        font-weight: 500;
        color: #343E3A;
        line-height: 0.833333rem;
    }
    .repayment_mttwo_cleft span{
        font-weight: bold;
        color: #DB861F;
    }
    .repayment_mttwo_cright{
        width: 1.888889rem;
        height: 0.833333rem;
        background: #00CA88;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 0.416667rem;
    }
    .repayment_mttwo_cright span{
        font-size: 13px;
        font-weight: 500;
        color: #FFFFFF;
    }
    .repayment_mtthr{
        width: 100%;
        height: auto;
    }
    .repayment_mtthr_cont{
        width: 100%;
        height: auto;
        display: flex;
        justify-content: flex-start;
    }
    .repayment_mtthr_cleft{
        width: 0.833333rem;
        height: 0.833333rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .repayment_mtthr_clicon{
        width: 14px;
        height: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .repayment_mtthr_cright{
        width: auto;
        font-size: 11px;
        font-weight: 500;
        color: #808080;
        line-height: 0.416667rem;
        box-sizing: border-box;
    }
    .repayment_mtthr_crtwo{
        color: #BDA170;
    }
    .repayment_down{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0 0.444444rem 0 0.444444rem;
        background: #ffffff;
        border-radius: 0.333333rem;
    }
    .repayment_ditems{
        width: 100%;
        height: 4.083333rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-top: 0.25rem;
    }
    .repayment_ditem{
        width: 100%;
        height: auto;
    }
    .repayment_dititle{
        width: 100%;
        height: 1.055556rem;
        font-size: 0.444444rem;
        font-weight: 500;
        color: #1A1A1A;
        line-height: 1.055556rem;
    }
    .repayment_dmview{
        width: 100%;
        height: 1.388889rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .repayment_dmleft{
        width: 1.111111rem;
        height: 1.388889rem;
    }
    .repayment_dmlimg{
        width: 1.111111rem;
        height: 1.111111rem;
    }
    .repayment_dmlimg img{
        display: block;
        width: 1.111111rem;
        height: 1.111111rem;
    }
    .repayment_dmright{
        width: 5.222222rem;
        font-size: 11px;
        font-weight: 500;
        color: #808080;
        line-height: 0.416667rem;
    }
    .repayment_dfview{
        width: 100%;
        height: 0.833333rem;
        display: flex;
        justify-content:space-between;
        align-items: center;
    }
    .repayment_dfleft{
        width: auto;
        font-size: 12px;
        font-weight: 500;
        color: #343E3A;
        line-height: 12px;
    }
    .repayment_dfleft span{
        padding-left: 0.083333rem;
        color: #DB861F
    }
    .repayment_dfright{
        width: 1.888889rem;
        height: 0.833333rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        border: 1px solid #00CA88;
        border-radius: 0.416667rem;
        font-size: 0.361111rem;
        font-weight: 500;
        color: #00CA88;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    /* 1px边框 底部*/
    .repayment_dfrscale-1px{
        position: relative;
        border:none;
    }
    .repayment_dfrscale-1px:after{
        content: '';
        position: absolute;
        bottom: 0;
        background: #E6E9E8;
        width: 100%;
        height: 1px;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
    }
    .recard_tite_wrap{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0.222222rem 0.361111rem;
        margin: 0 auto;
        background: #FFF2DC;
        border-radius: 0.333333rem;
        margin-bottom: 0.7222222rem;
        margin-top: 0.4rem;
    }
    .recard_list{
        width: 100%;
        min-height: 3.24rem;
        max-height: 11.1rem;
        overflow-x: hidden;
        overflow-y: scroll;
        box-sizing: border-box;
        padding: 0 0.444444rem 0.444444rem 0.444444rem;
    }
    .recard_items{
        width: 100%;
        height: 1.277778rem;
        display: flex;
        justify-content: space-between;
    }
    .recard_item_left{
        width: auto;
        height: 0.722222rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .recard_item_left span{
        font-size: 0.388889rem;
        font-weight: 500;
        color: #1A1A1A;
    }
    .recard_item_right{
        width: 1.583333rem;
        height: 0.722222rem;
        box-sizing: border-box;
        border-radius: 0.416667rem;
        border: .5px solid #00CA88;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .recard_item_right span{
        font-size: 12px;
        font-weight: 500;
        color: #00CA88;
    }
    .redetail_wrap{
        width: 100%;
        height: auto;
    }
    .redetail_title{
        width: 100%;
        height: 0.388889rem;
        display: flex;
        justify-content: flex-start;
    }
    .redetail_tleft{
        width: 0.055556rem;
        height: 0.388889rem;
        background: #2FA96B;
    }
    .redetail_tright{
        width: auto;
        height: 0.388889rem;
        padding-left: 0.111111rem;
        font-size: 0.388889rem;
        font-weight: 500;
        color: #1A1A1A;
        line-height: 0.388889rem;
    }
    .redetail_coupons_form{
        width: 100%;
        height: auto;
        overflow-x: hidden;
        overflow-y: scroll;
        box-sizing: border-box;
        padding: 0 0.444444rem 0.444444rem 0.444444rem;
    }

    .redetail_coupons_form .confirmloan_msgileft{
        font-size: 0.361111rem;
    }
    .redetail_coupons_form .confirmloan_msgiright{
        font-size: 0.361111rem;
    }
    .redetail_coupons_form .confirmloan_msgitems{
        height: 0.75rem;
    }
    .detail_scale-1px{
        position: relative;
        border:none;
    }
    .detail_scale-1px:after{
        content: '';
        position: absolute;
        bottom: 0;
        background: #E7E7E7;
        width: 100%;
        height: 1px;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
    }
    .verifycode_coupons_top_new{
        height: 1.5rem;
    }

</style>

<style>
    #repaymentonline .van-popup{
        background: none;
    }
</style>